import React from 'react';
import Dialog, { DialogContent, DialogTitle, DialogContentText } from 'material-ui/Dialog';
import Button from 'material-ui/Button';

export default class SimpleDialog extends React.Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    return (
      <div>
        <Button onClick={this.handleOpen} >{this.props.buttonLabel}</Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
        >
          <DialogTitle id="alert-dialog-slide-title">
            {this.props.title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {this.props.content}
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormComponents/Dialog/index.js